__turbopack_context__.v({
  "root": "DividerVertical-module__ASsOxW__root",
});
